import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import BodyWrap from "../../utils/BodyWrap";
import ProfilePic from "./ProfilePic";
import ProfileData from "./ProfileData";
import GeneralLoader from "../../GeneralLoader";
import ConfirmProfileInfoDialog from "./ConfirmProfileInfoDialog";

// CSS
import "../../../css/profile/profile-page.css";

// State
import { getTranslations } from "../../../store/actions/translations";
import { getReviewer } from "../../../store/actions/reviewers";
import { resetUpdateAccountSuccess, userLogout } from "../../../store/actions/user";

class ReviewerProfile extends Component {
	constructor(props) {
		super(props);

		// We will grab the initial has_logged_in status.  Who cares what the API returns at this point
		this.state = {
			initialHasLoggedIn: props.reviewer.user.has_logged_in
		};
	}

	static initialAction(store, props, translationKey = null) {
		const reviewer = store !== null ? store.getState().user.reviewer : props.reviewer;
		const promises = [];
		const translationSections = [
			"reviewer_form",
			"reviewer_first_login_dialog",
			"buttons",
			"form_elements",
			"languages"
		];

		if (translationKey === null) {
			translationKey = props.translationKey;
		}

		if (!reviewer) {
			if (store !== null) {
				promises.push(userLogout("reviewer"));
			} else {
				promises.push(props.userLogout("reviewer"));
			}
		} else {
			if (store !== null) {
				promises.push(getReviewer(reviewer.user.id, reviewer.token));
				promises.push(
					getTranslations([translationKey], translationSections, translationKey)
				);
			} else {
				promises.push(props.getReviewer(reviewer.user.id, reviewer.token));
				promises.push(
					props.getTranslations([translationKey], translationSections, translationKey)
				);
			}
		}

		return promises;
	}

	/*
	 * If component got new props, we should check if things are persisted.
	 * If so, go get the reviewer and translations
	 */
	componentDidUpdate(prevProps) {
		if (this.props.persisted && prevProps.persisted === false) {
			Promise.all(ReviewerProfile.initialAction(null, this.props));
		}
	}

	/*
	 * Component mounts and things are already persisted, just go get reviewer info
	 */
	componentWillMount() {
		if (this.props.persisted) {
			Promise.all(ReviewerProfile.initialAction(null, this.props));
		}
	}

	componentWillUnmount() {
		this.props.resetUpdateAccountSuccess();
	}

	render() {
		const { reviewerIsLoading, translationsLoading, translations } = this.props;
		const { user } = this.props.reviewer;
		const { initialHasLoggedIn } = this.state;

		return (
			<div className="body_container padded_top padded_bottom">
				<BodyWrap>
					{translationsLoading ? (
						<GeneralLoader />
					) : (
							<React.Fragment>
								<div className="content-header">
									<h1>{translations.pages[this.props.translationKey].title}</h1>
									<div className="page-text">
										{translations.pages[this.props.translationKey].content}
									</div>
								</div>
								<div>
									{!reviewerIsLoading ? (
										<GeneralLoader />
									) : (
											<React.Fragment>
												<ProfilePic user={user} translations={translations} />
												<ProfileData user={user} translations={translations} />
											</React.Fragment>
										)}
								</div>
								<ConfirmProfileInfoDialog
									initialShow={!initialHasLoggedIn}
									title={translations.sections.reviewer_first_login_dialog.title}
									btnTranslations={translations.sections.buttons}
								>
									<div
										className="enlarged-font"
										dangerouslySetInnerHTML={{
											__html:
												translations.sections.reviewer_first_login_dialog
													.content
										}}
									/>
								</ConfirmProfileInfoDialog>
							</React.Fragment>
						)}
				</BodyWrap>
			</div>
		);
	}
}

const mapStateToProps = (state, props) => {
	return {
		translationsLoading:
			state.translations.isLoading[props.translationKey] === undefined
				? 1
				: state.translations.isLoading[props.translationKey],
		translations: state.translations.translations,
		persisted: state.persist,
		reviewer: state.user.reviewer,
		reviewerIsLoading: !!state.reviewers.isLoading ? state.reviewers.isLoading : 1
	};
};

export default connect(
	mapStateToProps,
	{ getReviewer, resetUpdateAccountSuccess, userLogout, getTranslations }
)(ReviewerProfile);



// WEBPACK FOOTER //
// ./src/components/reviewer/profile/ReviewerProfile.js